import { SECTION, SECTION_SLUGS } from 'components/pages/jobForm/constants';

// configurations
export const SECTION_SLUGS_MAP = {
  [SECTION_SLUGS.INFO]: SECTION.INFO,
  [SECTION_SLUGS.REQUIREMENTS]: SECTION.REQUIREMENTS,
  [SECTION_SLUGS.DRESS_CODE]: SECTION.DRESS_CODE,
  [SECTION_SLUGS.LOCATION]: SECTION.LOCATION,
  [SECTION_SLUGS.SCHEDULE]: SECTION.SCHEDULE,
  [SECTION_SLUGS.TIME]: SECTION.TIME,
  [SECTION_SLUGS.WONOLOERS]: SECTION.WONOLOERS,
  [SECTION_SLUGS.PAY]: SECTION.PAY,
  [SECTION_SLUGS.FINAL]: SECTION.BUTTONS,
};

// this needs to be sync'd with the order of sections in the framework/content
const basePrsSectionFlowMap = {
  [SECTION.CHOOSER]: SECTION.INFO,
  [SECTION.INFO]: SECTION.DRESS_CODE,
  [SECTION.DRESS_CODE]: SECTION.REQUIREMENTS,
  [SECTION.REQUIREMENTS]: SECTION.LOCATION,
  [SECTION.LOCATION]: SECTION.TIME,
  [SECTION.TIME]: SECTION.WONOLOERS,
  [SECTION.WONOLOERS]: SECTION.PAY,
  [SECTION.PAY]: SECTION.BUTTONS,
  [SECTION.BUTTONS]: null
};

export const prsSectionFlowMap = basePrsSectionFlowMap;

const reverseFlow = (flowMap) => Object.keys(flowMap).reduce((acc, sectionId) => {
  const next = flowMap[sectionId];
  if (next) acc[next] = sectionId;
  return acc;
}, {});

export const prsReverseFlowMap = reverseFlow(prsSectionFlowMap);

export const initialValidSections = {
  [SECTION.CHOOSER]: true,
  [SECTION.INFO]: false,
  [SECTION.DRESS_CODE]: true,
  [SECTION.REQUIREMENTS]: false,
  [SECTION.LOCATION]: false,
  [SECTION.WHO]: false,
  [SECTION.SCHEDULE]: false,
  [SECTION.PAY]: false,
};

export const prsInitialValidSections = {
  [SECTION.CHOOSER]: true,
  [SECTION.INFO]: false,
  [SECTION.DRESS_CODE]: true,
  [SECTION.REQUIREMENTS]: false,
  [SECTION.LOCATION]: false,
  [SECTION.TIME]: false,
  [SECTION.WONOLOERS]: true,
  [SECTION.PAY]: false,
};
